export default {
  navigationState: JSON.parse(localStorage.getItem("navigation-state")) || true,
};
